import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/bangkok/sing-in.png")